import i18next from "i18next";
import { Menu, TriangleAlert } from "lucide-react";
import React from "react";
import { getI18n, useTranslation } from "react-i18next";
import { switchLocaleAction } from "../actions/switch-locale";
import CloseAlert from "../screens/menu/CloseAlert";
import fetchData from "../utils/api";
import { Config } from "../utils/config";
import CategoriesSlider from "./CategoriesSlider";
import DropDownList from "./DropDownList";
import { Button } from "./ui/button";
import { CardTitle } from "./ui/card";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Label } from "./ui/label";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

const isSelectedTypeNotInOrderingMethodData = (
  selectedType: string | null,
  orderingMethodData: { label: string; value: string }[]
): boolean => {
  if (selectedType) {
    return !orderingMethodData.some((method) => method.value === selectedType);
  }
  return false;
};

export default function Header({
  id,
  authToken,
  setCurrentSelected,
  currentSelected,
  cartTotal,
  restaurantDetail,
  restaurantMessage,
  isHeader,
  tableReservationCart,
  selectedType,
  setSelectedType,
  open,
  isLanguageOpen,
  menuCategories,
  setSelectedCategory,
  selectedCategory,
}) {
  const [isOpen, setOpen] = React.useState(false);
  const currentLanguage = getI18n();
  const { t } = useTranslation();
  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [isOrderingMethodOpen, setIsOrderingMethodOpen] = React.useState(
    selectedType === "" ? true : false
  );

  const [orderingMethodData, setOrderingMethodData] = React.useState<any>([]);
  const [isMethod, setIsMethod] = React.useState(
    selectedType === "dine_in" ||
      selectedType === "table_booking" ||
      selectedType === "table_reservation"
      ? false
      : true
  );

  React.useEffect(() => {
    setIsMethod(
      selectedType === "dine_in" ||
        selectedType === "table_booking" ||
        selectedType === "table_reservation"
        ? false
        : true
    );
  }, [selectedType]);

  React.useEffect(() => {
    setOrderingMethodData(
      Config.env.app.ordering_method_header.reduce((acc: any, item: any) => {
        if (
          (item.value === "table_reservation" &&
            !restaurantDetail.services.table_reservation) ||
          (item.value === "pickup" &&
            !restaurantDetail.services.pickup_service) ||
          (item.value === "delivery" &&
            !restaurantDetail.services.delivery_service) ||
          (item.value === "in_restaurant" &&
            (!restaurantDetail.services.table_reservation ||
              !restaurantDetail.tableReservation.allow_guest_pre_order)) ||
          item.value === "dine_in"
        ) {
          // Skip the item if the condition is not matched
          return acc;
        }
        return [...acc, item];
      }, [])
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restaurantDetail]);

  React.useEffect(() => {
    if (
      selectedType !== "dine_in" &&
      selectedType !== "table_booking" &&
      selectedType !== "table_reservation" &&
      orderingMethodData.length > 0
    ) {
      const result = isSelectedTypeNotInOrderingMethodData(
        selectedType,
        orderingMethodData
      );
      if (result === true) {
        setSelectedType("");
        const url = new URL(window.location.href);
        const params = url.searchParams;
        params.delete("type");

        window.history.pushState(null, "", url.toString());
        setIsOrderingMethodOpen(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderingMethodData, selectedType]);

  const handleOrderMethod = async ({ method }) => {
    const cachedCart = localStorage.getItem("cart");
    try {
      const body: any = {
        cart_id: cachedCart,
        ordering_method: method,
      };
      const res = await fetchData({
        url: "cart/change-ordering-method",
        method: "POST",
        body,
        token: authToken,
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleChangeLanguage = async ({ value }) => {
    i18next.changeLanguage(value);
    switchLocaleAction(value);
  };

  const alertMessage = restaurantMessage?.split("\n")
    ? restaurantMessage?.split("\n")[0]
    : restaurantMessage;
  return (
    <>
      {isHeader && (
        <header className="sticky top-0 bg-white border-l border-b z-10">
          <div className="px-4 sm:px-5 sm:pr-12 py-4 sm:py-5 flex flex-col sm:flex-row items-center gap-2.5 sm:gap-4">
            <div className="w-full flex items-center gap-2 md:gap-3 lg:gap-4">
              <Sheet open={isOpen} onOpenChange={(isOpen) => setOpen(isOpen)}>
                <SheetTrigger asChild>
                  <button className="flex-shrink-0 flex sm:hidden size-8 items-center justify-center bg-green rounded-lg">
                    <Menu className="size-4" />
                  </button>
                </SheetTrigger>
                <SheetContent side="left" className="">
                  <nav className="space-y-6 text-left text-lg font-medium">
                    {/* <Button
                  variant={"ghost"}
                  className="w-full flex items-center justify-start gap-2 text-lg font-semibold"
                >
                  <Package2 className="h-6 w-6" />
                </Button> */}
                    <CardTitle
                      onClick={() => {
                        setCurrentSelected("menu");
                      }}
                      className="w-full cursor-pointer pl-4"
                    >
                      {restaurantDetail?.name}
                    </CardTitle>

                    {Config.env.app.sidebar.map((item, index) => {
                      if (tableReservationCart && item.href === "menu") {
                        // If both conditions are true, do not render the item (return null)
                        return null;
                      }
                      return (
                        <Button
                          onClick={() => {
                            // Prevent navigation to "cart" if cartTotal is 0
                            // if (item.href === "cart" && cartTotal === 0) {
                            //   return;
                            // } else {
                            setCurrentSelected(item.href);
                            setOpen(false);
                            // }
                          }}
                          variant={"ghost"}
                          key={index}
                          className={`w-full text-left text-muted-foreground hover:text-foreground ${
                            currentSelected === item.href
                              ? "text-foreground"
                              : ""
                          }`}
                        >
                          <div className="w-full flex items-center gap-2">
                            {item.href === "cart" && cartTotal > 0 ? (
                              <React.Fragment>
                                <div className="relative">
                                  <div className="absolute -top-2.5 -right-3 rounded-full text-center w-5 h-5  bg-muted z-0">
                                    {cartTotal}
                                  </div>
                                  <item.icon />
                                </div>
                                {t(item.title)}
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <item.icon /> {t(item.title)}
                              </React.Fragment>
                            )}
                          </div>
                        </Button>
                      );
                    })}
                    <div className="pl-2 w-full flex items-center gap-2">
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <div className="w-full flex items-center gap-2">
                            <Button
                              variant="secondary"
                              size="icon"
                              className="rounded-full"
                            >
                              <img
                                src={
                                  Config.env.app.languages.find(
                                    (r) => r.value === currentLanguage.language
                                  )?.image || Config.env.app.languages[0].image
                                }
                                height={20}
                                width={20}
                                alt={
                                  Config.env.app.languages.find(
                                    (r) => r.value === currentLanguage.language
                                  )?.label || Config.env.app.languages[0].label
                                }
                              />
                            </Button>
                            <Label className="w-full text-left text-muted-foreground hover:text-foreground">
                              {t("languages.title")}
                            </Label>
                          </div>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent>
                          <DropdownMenuItem>
                            {t("languages.title")}
                          </DropdownMenuItem>
                          <DropdownMenuSeparator />
                          {Config.env.app.languages.map((item, index) => (
                            <DropdownMenuItem
                              className="flex gap-2"
                              key={index}
                              onClick={() => {
                                handleChangeLanguage({ value: item.value });
                              }}
                            >
                              <img
                                src={item.image}
                                height={20}
                                width={20}
                                alt={item.label}
                              />

                              {t(item.label)}
                            </DropdownMenuItem>
                          ))}
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </div>
                  </nav>
                </SheetContent>
              </Sheet>
              <CardTitle
                onClick={() => {
                  setCurrentSelected("menu");
                }}
                className="w-fit cursor-pointer"
              >
                {restaurantDetail?.name}
              </CardTitle>
            </div>

            <div className="w-full ml-auto flex items-end justify-end gap-3">
              {isMethod && (
                <div className="max-w-[200px] w-full">
                  <DropDownList
                    id="type"
                    className={"max-w-[300px]"}
                    label={t("cart.ordering_method.title")}
                    data={orderingMethodData}
                    placeholder={t("cart.ordering_method.placeholder")}
                    value={selectedType}
                    onValueChange={(e: any) => {
                      setSelectedType(e);
                      const url = new URL(window.location.href);
                      const params = url.searchParams;
                      params.set("type", e);

                      window.history.pushState(null, "", url.toString());
                      handleOrderMethod({ method: e });
                    }}
                  />
                </div>
              )}
              <div className="flex items-center gap-4">
                {Config.env.app.header.map((item, index) => {
                  if (tableReservationCart && item.href === "menu") {
                    return null;
                  }
                  return (
                    <TooltipProvider key={index}>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <button
                            onClick={() => {
                              setCurrentSelected(item.href);
                            }}
                            className={`relative size-10 flex items-center justify-center bg-green rounded-lg ${
                              currentSelected === item.href
                                ? "text-white bg-red"
                                : "bg-green text-green-400"
                            }`}
                          >
                            {item.href === "cart" && cartTotal > 0 ? (
                              <div>
                                <span className="flex absolute h-4 min-w-4 w-fit top-0 right-0 -mt-1 -mr-1">
                                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-black opacity-75"></span>
                                  <span className="relative inline-flex items-center justify-center rounded-full h-4 min-w-4 w-fit  bg-black z-0 text-[10px] leading-none text-white font-medium">
                                    {cartTotal}
                                  </span>
                                </span>
                                <item.icon />
                              </div>
                            ) : (
                              <item.icon />
                            )}
                          </button>
                          {/* <Button
                            type="button"
                            variant={"ghost"}
                            key={index}
                            className={`relative text-muted-foreground transition-colors hover:text-foreground ${
                              currentSelected === item.href
                                ? "text-foreground bg-muted"
                                : ""
                            }`}
                          >
                            {item.href === "cart" && cartTotal > 0 ? (
                              <div>
                                <div className="absolute -top-1 -right-1 rounded-full w-5 h-5  bg-muted z-0 grid place-content-center">
                                  <p className="text-xs  text-foreground ">
                                    {cartTotal}
                                  </p>
                                </div>
                                <item.icon />
                              </div>
                            ) : (
                              <item.icon />
                            )}
                          </Button> */}
                        </TooltipTrigger>
                        <TooltipContent>
                          <Label>{t(item.title)}</Label>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  );
                })}
              </div>
            </div>
          </div>
          {restaurantMessage !== "" && (
            <div className="p-2 sm:p-3 bg-green border-t">
              <div className="flex items-center justify-center gap-2">
                <h3 className="inline-flex gap-2 text-sm sm:text-base font-semibold animate-pulse">
                  <span>
                    <TriangleAlert className="size-5 sm:size-6" />
                  </span>
                  {""}
                  <span>
                    {alertMessage}{" "}
                    <span
                      className="underline cursor-pointer"
                      onClick={() => setOpenAlert(true)}
                    >
                      {t("view_more")}
                    </span>
                  </span>
                </h3>
              </div>
            </div>
          )}
          {currentSelected === "menu" && (
            <CategoriesSlider
              menuCategories={menuCategories}
              setSelectedCategory={setSelectedCategory}
              selectedCategory={selectedCategory}
            />
          )}
        </header>
      )}
      <CloseAlert
        message={restaurantMessage}
        setOpen={setOpenAlert}
        open={openAlert}
      />
    </>
  );
}
